export const queryKeys = {
  FLAT_LIST: 'FLAT_LIST',
  FLAT_FILTER: 'FLAT_FILTER',
  HOUSE_SHOW: 'HOUSE_SHOW'
};
